(function (root, factory) {
  if (typeof define === "function" && define.amd) {
    define([], function () {
      return factory(root);
    });
  } else if (typeof module === "object" && typeof module.exports === "object") {
    module.exports = factory(root);
  } else {
    root.Fnon = factory(root);
  }
})(
  typeof global !== "undefined"
    ? global
    : typeof window !== "undefined"
    ? window
    : this,
  function (window) {
    // Check SSR
    if (
      typeof window === "undefined" &&
      typeof window.document === "undefined"
    ) {
      return false;
    }

    var idEng = (length) => {
      var result = "";
      var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return "Fnon" + result;
    };

    const GSvg = {
      Success:
        '<svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="ani"><path fill="currentColor" d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z" class=""></path></svg>',
      Warning:
        '<svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" class="ani"><path fill="currentColor" d="M248.747 204.705l6.588 112c.373 6.343 5.626 11.295 11.979 11.295h41.37a12 12 0 0 0 11.979-11.295l6.588-112c.405-6.893-5.075-12.705-11.979-12.705h-54.547c-6.903 0-12.383 5.812-11.978 12.705zM330 384c0 23.196-18.804 42-42 42s-42-18.804-42-42 18.804-42 42-42 42 18.804 42 42zm-.423-360.015c-18.433-31.951-64.687-32.009-83.154 0L6.477 440.013C-11.945 471.946 11.118 512 48.054 512H527.94c36.865 0 60.035-39.993 41.577-71.987L329.577 23.985zM53.191 455.002L282.803 57.008c2.309-4.002 8.085-4.002 10.394 0l229.612 397.993c2.308 4-.579 8.998-5.197 8.998H58.388c-4.617.001-7.504-4.997-5.197-8.997z" class=""></path></svg>',
      Danger:
        '<svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="ani"><path fill="currentColor" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm101.8-262.2L295.6 256l62.2 62.2c4.7 4.7 4.7 12.3 0 17l-22.6 22.6c-4.7 4.7-12.3 4.7-17 0L256 295.6l-62.2 62.2c-4.7 4.7-12.3 4.7-17 0l-22.6-22.6c-4.7-4.7-4.7-12.3 0-17l62.2-62.2-62.2-62.2c-4.7-4.7-4.7-12.3 0-17l22.6-22.6c4.7-4.7 12.3-4.7 17 0l62.2 62.2 62.2-62.2c4.7-4.7 12.3-4.7 17 0l22.6 22.6c4.7 4.7 4.7 12.3 0 17z" class=""></path></svg>',
      Info: '<svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="ani"><path fill="currentColor" d="M256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm-36 344h12V232h-12c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h48c6.627 0 12 5.373 12 12v140h12c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12h-72c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12zm36-240c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z" class=""></path></svg>',
      Question:
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="ani"><path fill="currentColor" d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 448c-110.532 0-200-89.431-200-200 0-110.495 89.472-200 200-200 110.491 0 200 89.471 200 200 0 110.53-89.431 200-200 200zm107.244-255.2c0 67.052-72.421 68.084-72.421 92.863V300c0 6.627-5.373 12-12 12h-45.647c-6.627 0-12-5.373-12-12v-8.659c0-35.745 27.1-50.034 47.579-61.516 17.561-9.845 28.324-16.541 28.324-29.579 0-17.246-21.999-28.693-39.784-28.693-23.189 0-33.894 10.977-48.942 29.969-4.057 5.12-11.46 6.071-16.666 2.124l-27.824-21.098c-5.107-3.872-6.251-11.066-2.644-16.363C184.846 131.491 214.94 112 261.794 112c49.071 0 101.45 38.304 101.45 88.8zM298 368c0 23.159-18.841 42-42 42s-42-18.841-42-42 18.841-42 42-42 42 18.841 42 42z" class=""></path></svg>',
    };
    const GColors = {
      Primary: "#029eff",
      Success: "#39DA8A",
      Warning: "#fdd347",
      Danger: "#f55260",
      Info: "#56b6f7",
      Dark: "#222f3e",
      Light: "#fff",
    };
    let waitingAndBoxColors = gShades(GColors.Primary, 9);
    let defaultFont = "'Quicksand', sans-serif";
    let docDetailsUrl =
      "\n Visit https://github.com/superawdi/Fnon to learn more..";

    // helper functions
    function toHtml(str) {
      return new DOMParser().parseFromString(str, "text/html").body.firstChild;
    }

    function toRGB(color) {
      // create fake div
      let f = document.createElement("div");
      f.style.color = color;
      f.style.display = "none";
      document.body.appendChild(f);
      // get color of div
      let cs = window.getComputedStyle(f),
        pv = cs.getPropertyValue("color");
      // remove div after obtaining desired color value
      document.body.removeChild(f);
      return pv;
    }

    function gShades(color, length) {
      let rgb = toRGB(color);
      const sp = rgb
        .replace("rgb(", "")
        .replace(")", "")
        .split(",")
        .map((c) => c.trim());
      var r = sp[0] % 256;
      var g = sp[1] % 256;
      var b = sp[2] % 256;
      var result = [rgb];
      for (var i = 0; i < length; i++) {
        r -= 33;
        g -= 33;
        b -= 33;
        result.push("rgb(" + r + "," + g + "," + b + ")");
      }
      return result;
    }

    function Init(s, o) {
      if (o && typeof o === "object") return { ...s, ...o };
      return s;
    }
    // console functions
    var cError = function (title, message) {
      return console.error(
        "%c " + title + " ",
        "padding:2px;border-radius:6px;color:#fff;background:red",
        "\n" + message + docDetailsUrl
      );
    };

    function truncate(val) {
      if (!val) return "";
      if (val.length > 10) {
        return val.substring(0, 9) + "..";
      }
      return val;
    }

    var deafultBtnTheme = {
      text: "Button",
      color: GColors.Dark,
      background: GColors.Light,
      shadow: "rgba(0, 0, 0, 0.1)",
      borderColor: "#d4d4d4",
      css: undefined,
    };
    //#region Ask
    // Deafult settings for Ask,Alert and Dialogue
    let aadDefault = {
      fontFamily: defaultFont,
      width: "nl", // sm//lg//nl//xl
      closeButton: true,
      animation: "slide-top",
      autoFocusTag: "input:not([disabled])",
      autoFocus: false,
      autoFocusDelay: 0,
      closeButton: false,
      callback: undefined,
      cancelCallback: undefined,
      icon: undefined,
      iconColor: GColors.Dark,
      showIcon: false,
      message: "",

      title: "",
      titleColor: GColors.Dark,
      titleBackground: GColors.Light,

      btnOkText: "Ok",
      btnOkColor: GColors.Dark,
      btnOkBackground: GColors.Light,
      btnOkShadow: "rgba(0, 0, 0, 0.2)",
      btnOkBorderColor: "#d4d4d4",

      btnCancelText: "Cancel",
      btnCancelColor: GColors.Dark,
      btnCancelBackground: GColors.Light,
      btnCancelShadow: "rgba(0, 0, 0, 0.1)",
      btnCancelBorderColor: "#d4d4d4",

      color: "#2b2b2b",
      background: "rgba(0, 0, 0, 0.4)",

      zIndex: 4000,

      beforeShow: undefined,
      afterShow: undefined,

      delButtons: false,

      showMaxMin: false, // show maximum button

      showMin: false,

      layout: "hbf", // head -> body -> footer
    };

    let aadThemes = {
      Primary: {
        titleColor: GColors.Light,
        titleBackground: GColors.Primary,
        btnOkColor: GColors.Light,
        btnOkBackground: GColors.Primary,
        btnOkBorderColor: "transparent",
      },
      Success: {
        titleColor: GColors.Light,
        titleBackground: GColors.Success,

        btnOkColor: GColors.Light,
        btnOkBackground: GColors.Success,
        btnOkBorderColor: "transparent",

        icon: GSvg.Success,
        iconColor: GColors.Success,
      },
      Warning: {
        titleColor: GColors.Dark,
        titleBackground: GColors.Warning,

        btnOkColor: GColors.Dark,
        btnOkBackground: GColors.Warning,
        btnOkBorderColor: "transparent",

        icon: GSvg.Warning,
        iconColor: GColors.Warning,
      },
      Danger: {
        titleColor: GColors.Light,
        titleBackground: GColors.Danger,

        btnOkColor: GColors.Light,
        btnOkBackground: GColors.Danger,
        btnOkBorderColor: "transparent",

        icon: GSvg.Danger,
        iconColor: GColors.Danger,
      },
      Info: {
        titleColor: GColors.Light,
        titleBackground: GColors.Info,

        btnOkColor: GColors.Light,
        btnOkBackground: GColors.Info,
        btnOkBorderColor: "transparent",

        icon: GSvg.Info,
        iconColor: GColors.Info,
      }, //222f3e
      Dark: {
        titleColor: GColors.Light,
        titleBackground: GColors.Dark,

        btnOkColor: GColors.Light,
        btnOkBackground: GColors.Dark,
        btnOkBorderColor: "transparent",
        btnOkShadow: "rgba(255, 255, 255, 0.1)",
      },
      Light: {},
    };
    // ask settings
    let askSettings = { ...aadDefault };
    let dialogueSettings = { ...aadDefault };
    let alertSettings = { ...aadDefault };

    function delModel(m, o) {
      if (o.onClosing && typeof o.onClosing === "function") {
        o.onClosing(m);
      }
      m.style.pointerEvents = "none";
      m.style.opacity = 0;
      setTimeout(() => {
        m.remove();
        if (!document.querySelectorAll("div.f__cm").length > 0)
          document.body.classList.remove("f__of_hidden");
        if (o.onClosed && typeof o.onClosed === "function") {
          o.onClosed(m);
        }
      }, 300);
    }
    // render ask
    function ra(o, mType) {
      let _icon =
        mType == "dialogue"
          ? ""
          : `${
              o.showIcon && o.icon
                ? `<div class="askicon" style="--icon-c:${o.iconColor}">${o.icon}</div>`
                : ""
            }`;
      let customButtons =
        mType === "dialogue" &&
        o.buttons &&
        Array.isArray(o.buttons) &&
        o.buttons.length > 0;
      let _btns = "";
      if (o.delButtons) {
      } else if (customButtons) {
        _btns = `<div class="f__m__f">${o.buttons.reduce((ac, st, i) => {
          var _xst = { ...deafultBtnTheme };
          if (st.style && st.style != "Light" && aadThemes[st.style]) {
            _xst.color = aadThemes[st.style].btnOkColor;
            _xst.background = aadThemes[st.style].btnOkBackground;
            _xst.borderColor = aadThemes[st.style].btnOkBorderColor;
          }
          var xst = { ..._xst, ...st };
          ac += `<button class="f__btn ${
            xst.css ?? ""
          }" data-i="${i}" style="background:${xst.background};color:${
            xst.color
          };--b-sh:${xst.shadow};border-color:${xst.borderColor};">${
            xst.text
          }</button>`;
          return ac;
        }, "")}</div>`;
      } else {
        _btns = `<div class="f__m__f">${
          mType != "alert"
            ? `<button class="f__btn" data-evt="ccl" style="background:${o.btnCancelBackground};color:${o.btnCancelColor};--b-sh:${o.btnCancelShadow};border-color:${o.btnCancelBorderColor};">${o.btnCancelText}</button>`
            : ""
        }<button class="f__btn" data-al="true" data-evt="tr" style="background:${
          o.btnOkBackground
        };color:${o.btnOkColor};--b-sh:${o.btnOkShadow};border-color:${
          o.btnOkBorderColor
        };">${o.btnOkText}</button></div>`;
      }
      var color = `style="color:${o.titleColor};"`;
      let head = o.title
        ? `<div class="f__m__h" style="background:${
            o.titleBackground
          };"><h5 class="f__m__h__ttl" ${color}>${o.title}</h5>${
            !o.closeButton
              ? ""
              : `<div style="display:flex;">${
                  o.showMin && mType === "dialogue"
                    ? `<button type="button" title="Minimize" data-al="true" data-evt="min" class="cls"><svg xmlns="http://www.w3.org/2000/svg" width="800px" height="800px" viewBox="0 0 24 24" fill="none"><path d="M6 11H18V13H6V11Z" fill="${o.titleColor}"/>
</svg></button>`
                    : ""
                }${
                  o.showMaxMin
                    ? `<button type="button" title="Max - Min" data-al="true" data-evt="max" class="cls"><svg  xmlns="http://www.w3.org/2000/svg" style="transform:scale(.9)" viewBox="0 0 473 473"  xml:space="preserve"><g><g><path fill="${o.titleColor}" d="M459.5,0H330.4c-7.5,0-13.5,6-13.5,13.5s6,13.5,13.5,13.5h96.5L218.8,235.1c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4
            s6.9-1.3,9.5-4L446,46.1v96.5c0,7.5,6,13.5,13.5,13.5s13.5-6,13.5-13.5V13.5C473,6,467,0,459.5,0z"/>
        <path fill="${o.titleColor}" d="M459.5,231.2c-7.5,0-13.5,6-13.5,13.5v130.9c0,38.8-31.6,70.4-70.4,70.4H97.4C58.6,446,27,414.4,27,375.6V97.4 C27,58.6,58.6,27,97.4,27h129.9c7.5,0,13.5-6,13.5-13.5S234.8,0,227.3,0H97.4C43.7,0,0,43.7,0,97.4v278.2
            C0,429.3,43.7,473,97.4,473h278.2c53.7,0,97.4-43.7,97.4-97.4V244.7C473,237.2,467,231.2,459.5,231.2z"/>
    </g></g></svg></button>`
                    : ""
                }<button type="button" data-al="true" data-evt="ccl" class="cls"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" ${color}><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></button></div>`
          }</div>`
        : "";
      let body = `<div class="f__m__b">${_icon}<div class="f__m__b__ask ${
        mType == "dialogue" ? "" : "ico"
      }" styel="--color:${o.color}"></div></div>`;
      let htmlContent = "";

      if (!o.layout || o.layout === "hbf") {
        htmlContent = head + body + _btns;
      } else {
        var st = new Set();
        o.layout
          .split("")
          .filter((c) => "hbf".includes(c) && c.trim().length > 0)
          .forEach((c) => st.add(c));
        st.forEach((ch) => {
          if (ch === "h") {
            htmlContent += head;
          } else if (ch === "b") {
            htmlContent += body;
          } else if (ch === "f") {
            htmlContent += _btns;
          }
        });
      }
      let html = `<div class="f__cm${
        o.width === "fl" ? " fl" : ""
      }" style="--f-f:${o.fontFamily};--m-bg:${
        o.background
      };--fnon-scroll-color:${o.titleBackground};z-index:${
        o.zIndex
      };transition: width 2s;"><div class="f__m f__m__${o.width} ${
        o.animation
      }">${htmlContent}</div></div>`;

      html = toHtml(html);
      if (o.onInit && typeof o.onInit === "function") o.onInit(html);
      var con = html.querySelector(".f__m__b__ask");
      if (o.message instanceof HTMLElement) {
        con.append(o.message);
      } else {
        con.innerHTML = o.message;
      }

      //${typeof o.message ==='string'?o.message:''}
      // close and cancel buttons button
      if (mType != "alert") {
        const cls = html.querySelectorAll('[data-evt="ccl"]');
        if (cls) {
          Array.from(cls).forEach((c) => {
            if (mType == "dialogue") {
              c.addEventListener("click", function (event) {
                if (
                  o.cancelCallback &&
                  typeof o.cancelCallback === "function"
                ) {
                  let res = o.cancelCallback(
                    () => {
                      delModel(html, o);
                    },
                    html.querySelector("div.f__m__b__ask"),
                    event
                  );
                  if (res === null || res === undefined || res === true) {
                    delModel(html, o);
                  }
                } else {
                  delModel(html, o);
                }
              });
            } else {
              c.addEventListener("click", function () {
                delModel(html, o);
                if (o.callback && typeof o.callback === "function") {
                  o.callback(false);
                }
              });
            }
          });
        }
        if (customButtons) {
          html.querySelectorAll(".f__m__f button").forEach((el) => {
            let ff = o.buttons[el.dataset.i];
            if (ff && ff.callback && typeof ff.callback === "function") {
              el.addEventListener("click", (e) => {
                let res = ff.callback(
                  () => {
                    delModel(html, o);
                  },
                  html.querySelector("div.f__m__b__ask"),
                  e
                );
                if (res === null || res === undefined || res === true) {
                  delModel(html, o);
                }
              });
            } else {
              el.addEventListener("click", () => delModel(html, o));
            }
          });
        } else {
          // button Ok
          //button:not([data-evt])
          const btn = html.querySelector('[data-evt="tr"]');
          if (btn) {
            btn.addEventListener("click", (event) => {
              if (o.callback && typeof o.callback === "function") {
                if (mType == "dialogue") {
                  let res = o.callback(
                    () => {
                      delModel(html, o);
                    },
                    html.querySelector("div.f__m__b__ask"),
                    event
                  ); //f__m__b__ask//p.f__m__b
                  if (res === null || res === undefined || res === true) {
                    delModel(html, o);
                  }
                } else {
                  o.callback(true, event);
                  delModel(html, o);
                }
              } else {
                delModel(html, o);
              }
            });
          }
        }
      } else {
        const cl = html.querySelectorAll('[data-al="true"]');
        Array.from(cl).forEach((c) => {
          c.addEventListener("click", function (event) {
            if (o.callback && typeof o.callback === "function") {
              o.callback(event);
            }
            delModel(html, o);
          });
        });
      }
      if (o.defaultBefore && typeof o.defaultBefore === "function") {
        o.defaultBefore(html);
      }
      if (o.beforeShow && typeof o.beforeShow === "function") {
        o.beforeShow(html);
      }
      var max = html.querySelector('button[data-evt="max"]');
      if (max) {
        max.addEventListener("click", function () {
          if (html.classList.contains("fl")) {
            // document.querySelectorAll()
            html.classList.remove("fl");
            html.querySelector(".f__m").classList.remove("f__m__fl");
          } else {
            // this.oldcss=
            html.classList.add("fl");
            html.querySelector(".f__m").classList.add("f__m__fl");
          }
        });
      }
      var min = html.querySelector('button[data-evt="min"]');
      if (min) {
        min.addEventListener("click", function () {
          var taskbar = document.querySelector("div[fnon-task-bar]");
          if (!taskbar) {
            taskbar = document.createElement("div");
            taskbar.style = `position: fixed;padding:4px;bottom: 0;left: 0;right: 0;box-shadow: black 4em 8px 11px;background: ${
              aadDefault.btnCancelBackground
            };z-index: ${dialogueSettings.zIndex - 1};`;
            taskbar.setAttribute("fnon-task-bar", "");
            document.body.append(taskbar);
          }
          // add button to taskbar
          var btn = toHtml(
            `<button class="f__btn" data-evt="ccl" style="background:${
              aadDefault.btnCancelBackground
            };color:${aadDefault.btnCancelColor};--b-sh:${
              aadDefault.btnCancelShadow
            };border-color:${
              aadDefault.btnCancelBorderColor
            };margin-right:6px;font-size:10px;" title="${o.title}">${truncate(
              o.title
            )}</button>`
          );
          taskbar.append(btn);
          btn.addEventListener("click", () => {
            html.style.display = "flex";
            document.body.classList.add("f__of_hidden");
            btn.remove();
            if (taskbar.children.length === 0) taskbar.remove();
          });
          // hide html
          html.style.display = "none";
          document.body.classList.remove("f__of_hidden");
        });
      }
      // const body =document.querySelector('body');
      document.body.classList.add("f__of_hidden");
      document.body.appendChild(html);
      if (o.defaultAfter && typeof o.defaultAfter === "function") {
        o.defaultAfter(html);
      }
      if (o.afterShow && typeof o.afterShow === "function") {
        o.afterShow(html);
      }
      // autofocus first input
      if (o.autoFocus) {
        var fi = html.querySelector(o.autoFocusTag);
        if (fi) setTimeout(() => fi.focus(), o.autoFocusDelay);
      } else {
        setTimeout(() => {
          var fi = html.querySelector(".f__btn");
          if (fi) fi.focus();
        }, o.autoFocusDelay);
      }
      return html;
    }

    const addAsk = (settings) => {
      return (message, title, ok, cancel, callback) => {
        if (message && message != "") {
          let res = { ...askSettings, ...settings };
          if (
            !(message instanceof HTMLElement) &&
            typeof message === "object"
          ) {
            res = { ...res, ...message };
          } else {
            res.message = message;
            if (title) res.title = title;
            if (ok) res.btnOkText = ok;
            if (cancel) res.btnCancelText = cancel;
            if (callback) res.callback = callback;
          }
          // save in case of delButtons=true to return remove Model function
          const a = ra(res);
          if (res.delButtons)
            return () => {
              delModel(a, res);
            };
        } else {
          cError("Message Null", "Message Can not be null !!!");
        }
      };
    };

    const Ask = {};
    Ask.Init = (o) => {
      askSettings = Init(askSettings, o);
    };
    Object.keys(aadThemes).forEach((c) => {
      Ask[c] = addAsk(aadThemes[c]);
      // Ask[c] = (message, title, ok, cancel, callback) => {
      //   if (message && message != "") {
      //     let res = { ...askSettings, ...aadThemes[c] };
      //     if (
      //       !(message instanceof HTMLElement) &&
      //       typeof message === "object"
      //     ) {
      //       res = { ...res, ...message };
      //     } else {
      //       res.message = message;
      //       if (title) res.title = title;
      //       if (ok) res.btnOkText = ok;
      //       if (cancel) res.btnCancelText = cancel;
      //       if (callback) res.callback = callback;
      //     }
      //     // save in case of delButtons=true to return remove Model function
      //     const a = ra(res);
      //     if (res.delButtons)
      //       return () => {
      //         delModel(a, res);
      //       };
      //   } else {
      //     cError("Message Null", "Message Can not be null !!!");
      //   }
      // };
    });

    const addDialogue = (settings) => {
      return (body, title, ok, cancel, okcallback, cancelcallback) => {
        if (body && body != "") {
          let res = { ...dialogueSettings, ...settings };
          if (!(body instanceof HTMLElement) && typeof body === "object") {
            res = { ...res, ...body };
          } else {
            res.message = body;
            if (title) res.title = title;
            if (ok) res.btnOkText = ok;
            if (cancel) res.btnCancelText = cancel;
            if (okcallback) res.callback = okcallback;
            if (cancelcallback) res.cancelCallback = cancelcallback;
          }
          const a = ra(res, "dialogue");
          if (res.delButtons)
            return () => {
              delModel(a, res);
            };
        } else {
          cError("Message Null", "Body not be null !!!");
        }
      };
    };

    const Dialogue = {};
    Dialogue.Init = (o) => {
      dialogueSettings = Init(dialogueSettings, o);
    };
    Object.keys(aadThemes).forEach((c) => {
      // let settings = { ...dialogueSettings, ...aadThemes[c] };
      Dialogue[c] = addDialogue(aadThemes[c]);
      // Dialogue[c] = (body, title, ok, cancel, okcallback, cancelcallback) => {
      //   if (body && body != "") {
      //     let res = { ...dialogueSettings, ...aadThemes[c] };
      //     if (!(body instanceof HTMLElement) && typeof body === "object") {
      //       res = { ...res, ...body };
      //     } else {
      //       res.message = body;
      //       if (title) res.title = title;
      //       if (ok) res.btnOkText = ok;
      //       if (cancel) res.btnCancelText = cancel;
      //       if (okcallback) res.callback = okcallback;
      //       if (cancelcallback) res.cancelCallback = cancelcallback;
      //     }
      //     const a = ra(res, "dialogue");
      //     if (res.delButtons)
      //       return () => {
      //         delModel(a, res);
      //       };
      //   } else {
      //     cError("Message Null", "Body not be null !!!");
      //   }
      // };
    });

    const addAlert = (settings) => {
      return (message, title, ok, callback) => {
        if (message && message != "") {
          let res = { ...alertSettings, ...settings };
          if (
            !(message instanceof HTMLElement) &&
            typeof message === "object"
          ) {
            res = { ...res, ...message };
          } else {
            res.message = message;
            if (title) res.title = title;
            if (ok) res.btnOkText = ok;
            if (callback) res.callback = callback;
          }
          const a = ra(res, "alert");
          if (res.delButtons)
            return () => {
              delModel(a, res);
            };
        } else {
          cError("Message Null", "Message Can not be null !!!");
        }
      };
    };

    const Alert = {};
    Alert.Init = (o) => {
      alertSettings = Init(alertSettings, o)
    };
    Object.keys(aadThemes).forEach((c) => {
      Alert[c] = addAlert(aadThemes[c]);
      // Alert[c] = (message, title, ok, callback) => {
      //   if (message && message != "") {
      //     let res = { ...alertSettings, ...aadThemes[c] };
      //     if (
      //       !(message instanceof HTMLElement) &&
      //       typeof message === "object"
      //     ) {
      //       res = { ...res, ...message };
      //     } else {
      //       res.message = message;
      //       if (title) res.title = title;
      //       if (ok) res.btnOkText = ok;
      //       if (callback) res.callback = callback;
      //     }
      //     const a = ra(res, "alert");
      //     if (res.delButtons)
      //       return () => {
      //         delModel(a, res);
      //       };
      //   } else {
      //     cError("Message Null", "Message Can not be null !!!");
      //   }
      // };
    });
    //#endregion

    //#region Hint
    let hs = {
      fontFamily: defaultFont,
      position: "right-top", //right-center// right-bottom// left-top // left-center // left-bottom // center-top // center-center // center-bottom
      spacing: "16px",
      svgSize: { w: "16px", h: "16px" },
      textColor: "#fff",
      fontSize: "14px",
      backgroundColor: "#029eff",
      shadowColor: "rgba(2, 158, 255, 0.3)",
      width: "300px",
      zindex: 4000,
      animation: "slide-left", // fade // slide-left // slide-right // slide-bottom // slide-top
      animationDuration: 500,
      displayDuration: 3000,
      progressColor: "rgba(255,255,255,0.9)",
      callback: undefined,
      title: undefined,
    };

    function rh(m, o) {
      let _title = o.title
        ? `<span style="font-weight:bold;font-size:1.025em;">${o.title}</span><br/>`
        : "";
      let html = `<div class="f__h ${
        o.animation ? o.animation : ""
      }" style="--hint-color:${o.textColor};--hint-bg-color:${
        o.backgroundColor
      };--hint-shadow-color:${o.shadowColor};font-size:${o.fontSize};--svg-h:${
        o.svgSize.h
      };--svg-w:${o.svgSize.w};--h-width:${o.width};--ani-dura:${
        o.animationDuration
      }ms;--display-dur:${o.displayDuration}ms;--prog-color:${
        o.progressColor
      }">${o.svg ? o.svg : ""}<span style="font-family:${o.fontFamily};">${
        _title + m
      }</span></div>`;
      html = toHtml(html);
      let tag = ".f__ch." + o.position;
      let c = document.querySelector(tag);
      if (!c) {
        c = toHtml(
          `<div class="f__ch ${o.position}" style="--h-spacing:${o.spacing}"></div>`
        );
        document.body.appendChild(c);
      }
      c.appendChild(html);
      setTimeout(() => {
        html.remove();
        if (o.callback && typeof o.callback === "function") {
          o.callback();
        }
        setTimeout(() => {
          if (c.children.length === 0) c.remove();
        }, o.displayDuration);
      }, o.displayDuration + o.animationDuration);
    }

    const hints = {
      Primary: {
        textColor: "#fff",
        backgroundColor: GColors.Primary,
        shadowColor: "rgba(2, 158, 255, 0.3)",
        svg: null,
      },
      Light: {
        textColor: GColors.Dark,
        backgroundColor: GColors.Light,
        shadowColor: "rgba(34, 47, 62, 0.3)",
        svg: null,
      },
      Dark: {
        textColor: "#fff",
        backgroundColor: GColors.Dark,
        shadowColor: "rgba(34, 47, 62, 0.3)",
        svg: null,
      },
      Success: {
        textColor: "#fff",
        backgroundColor: GColors.Success,
        shadowColor: "rgba(57, 218, 138, 0.3)",
        svg: GSvg.Success,
      },
      Warning: {
        textColor: "#fff",
        backgroundColor: GColors.Warning,
        shadowColor: "rgba(253, 211, 71, 0.3)",
        svg: GSvg.Warning,
      },
      Danger: {
        textColor: "#fff",
        backgroundColor: GColors.Danger,
        shadowColor: "rgba(245, 82, 96, 0.3)",
        svg: GSvg.Danger,
      },
      Info: {
        textColor: "#fff",
        backgroundColor: GColors.Info,
        shadowColor: "rgba(86, 182, 247, 0.3)",
        svg: GSvg.Info,
      },
    };

    const addHint = (settings = {}) => {
      return (m, o) => {
        if (m) {
          // hints;
          let ele = settings;
          let s =
            o && typeof o === "object"
              ? { ...hs, ...ele, ...o }
              : { ...hs, ...ele };
          if (o && typeof o === "function") s.callback = o;
          if (o && typeof o !== "object" && typeof o !== "function") {
            s.title = o;
          }
          rh(m, s);
        } else {
          cError(
            "Message Empty!",
            "Hint body can not be displayed if message is null."
          );
        }
      };
    };
    const Hint = {};
    Hint.Init = (o) => {
      hs = Init(hs, o);
    };
    Object.keys(hints).forEach((c) => {
      Hint[c] = addHint(hints[c]);
      // Hint[c] = (m, o) => {
      //   if (m) {
      //     let ele = hints[c];
      //     let s =
      //       o && typeof o === "object"
      //         ? { ...hs, ...ele, ...o }
      //         : { ...hs, ...ele };
      //     if (o && typeof o === "function") s.callback = o;
      //     if (o && typeof o !== "object" && typeof o !== "function") {
      //       s.title = o;
      //     }
      //     rh(m, s);
      //   } else {
      //     cError(
      //       "Message Empty!",
      //       "Hint body can not be displayed if message is null."
      //     );
      //   }
      // };
    });
    //#endregion

    //#region Wait
    let ws = {
      // waiting settings
      cid: idEng(12),
      svgSize: { w: "100px", h: "100px" },
      svgColor: "#029eff",
      textColor: "#029eff",
      textSize: "16px",
      clickToClose: true,
      fontFamily: defaultFont,
      background: "rgba(255,255,255,0.5)",
      zindex: 4000,
      containerSize: "350px",
    };
    let waitAndBoxSvg = {
      Infinity: () =>
        `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"  viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><path fill="none" stroke="${waitingAndBoxColors[0]}" stroke-width="4" stroke-dasharray="133.42624267578125 123.162685546875" d="M24.3 30C11.4 30 5 43.3 5 50s6.4 20 19.3 20c19.3 0 32.1-40 51.4-40 C88.6 30 95 43.3 95 50s-6.4 20-19.3 20C56.4 70 43.6 30 24.3 30z" stroke-linecap="round" style="transform:scale(0.8);transform-origin:50px 50px"><animate attributeName="stroke-dashoffset" repeatCount="indefinite" dur="1s" keyTimes="0;1" values="0;256"></animate></path></svg>`,
      Ripple: () =>
        `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"  viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><circle cx="50" cy="50" r="0" fill="none" stroke="${waitingAndBoxColors[0]}" stroke-width="6"><animate attributeName="r" repeatCount="indefinite" dur="1s" values="0;40" keyTimes="0;1" keySplines="0 0.2 0.8 1" calcMode="spline" begin="-0.5s"></animate><animate attributeName="opacity" repeatCount="indefinite" dur="1s" values="1;0" keyTimes="0;1" keySplines="0.2 0 0.8 1" calcMode="spline" begin="-0.5s"></animate></circle><circle cx="50" cy="50" r="0" fill="none" stroke="${waitingAndBoxColors[1]}" stroke-width="6"><animate attributeName="r" repeatCount="indefinite" dur="1s" values="0;40" keyTimes="0;1" keySplines="0 0.2 0.8 1" calcMode="spline"></animate><animate attributeName="opacity" repeatCount="indefinite" dur="1s" values="1;0" keyTimes="0;1" keySplines="0.2 0 0.8 1" calcMode="spline"></animate></circle></svg>`,
      Liquid: () =>
        `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"  viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><circle cx="50" cy="50" r="43" stroke="${waitingAndBoxColors[0]}" stroke-width="5" fill="none"></circle><path d="M12 50 Q31 40 50 50 Q69 60 88 50 A38 38 0 0 1 12 50" fill="${waitingAndBoxColors[3]}"><animate attributeName="d" repeatCount="indefinite" dur="1s" calcMode="spline" keyTimes="0;0.5;1" values="M12 50 Q31 40 50 50 Q69 60 88 50 A38 38 0 0 1 12 50;M12 50 Q31 60 50 50 Q69 40 88 50 A38 38 0 0 1 12 50;M12 50 Q31 40 50 50 Q69 60 88 50 A38 38 0 0 1 12 50" keySplines="0.5 0 0.5 1;0.5 0 0.5 1"></animate></path></svg>`,
      ColorBar: () =>
        `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"  viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><defs><clipPath id="ldio-4jm8omtt4e-cp" x="0" y="0" width="100" height="100"><path d="M81.3,58.7H18.7c-4.8,0-8.7-3.9-8.7-8.7v0c0-4.8,3.9-8.7,8.7-8.7h62.7c4.8,0,8.7,3.9,8.7,8.7v0C90,54.8,86.1,58.7,81.3,58.7z"></path></clipPath></defs><path fill="none" stroke="${waitingAndBoxColors[0]}" stroke-width="2.7928" d="M82 63H18c-7.2,0-13-5.8-13-13v0c0-7.2,5.8-13,13-13h64c7.2,0,13,5.8,13,13v0C95,57.2,89.2,63,82,63z"></path><g clip-path="url(#ldio-4jm8omtt4e-cp)"><g><rect x="-100" y="0" width="25" height="100" fill="${waitingAndBoxColors[4]}"></rect><rect x="-75" y="0" width="25" height="100" fill="${waitingAndBoxColors[3]}"></rect><rect x="-50" y="0" width="25" height="100" fill="${waitingAndBoxColors[2]}"></rect><rect x="-25" y="0" width="25" height="100" fill="${waitingAndBoxColors[1]}"></rect><rect x="0" y="0" width="25" height="100" fill="${waitingAndBoxColors[4]}"></rect><rect x="25" y="0" width="25" height="100" fill="${waitingAndBoxColors[3]}"></rect><rect x="50" y="0" width="25" height="100" fill="${waitingAndBoxColors[2]}"></rect><rect x="75" y="0" width="25" height="100" fill="${waitingAndBoxColors[1]}"></rect><animateTransform attributeName="transform" type="translate" dur="1s" repeatCount="indefinite" keyTimes="0;1" values="0;100"></animateTransform></g></g></svg>`,
      ProgressBar: () =>
        `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"  viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><defs><clipPath id="ldio-93bom2a7rr-cp" x="0" y="0" width="100" height="100"><rect x="0" y="0" width="0" height="100"><animate attributeName="width" repeatCount="indefinite" dur="1s" values="0;100;100" keyTimes="0;0.5;1"></animate><animate attributeName="x" repeatCount="indefinite" dur="1s" values="0;0;100" keyTimes="0;0.5;1"></animate></rect></clipPath></defs><path fill="none" stroke="${waitingAndBoxColors[0]}" stroke-width="2.7928" d="M82 63H18c-7.2 0-13-5.8-13-13v0c0-7.2 5.8-13 13-13h64c7.2 0 13 5.8 13 13v0C95 57.2 89.2 63 82 63z"></path><path fill="${waitingAndBoxColors[1]}" clip-path="url(#ldio-93bom2a7rr-cp)" d="M81.3 58.7H18.7c-4.8 0-8.7-3.9-8.7-8.7v0c0-4.8 3.9-8.7 8.7-8.7h62.7c4.8 0 8.7 3.9 8.7 8.7v0C90 54.8 86.1 58.7 81.3 58.7z"></path></svg>`,
      CurveBar: () =>
        `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><g transform="translate(50,50)"><circle cx="0" cy="0" r="8.333333333333334" fill="none" stroke="${waitingAndBoxColors[0]}" stroke-width="4" stroke-dasharray="26.179938779914945 26.179938779914945"><animateTransform attributeName="transform" type="rotate" values="0 0 0;-360 0 0" times="0;1" dur="1s" calcMode="spline" keySplines="0.2 0 0.8 1" begin="0" repeatCount="indefinite"></animateTransform></circle><circle cx="0" cy="0" r="16.666666666666668" fill="none" stroke="${waitingAndBoxColors[1]}" stroke-width="4" stroke-dasharray="52.35987755982989 52.35987755982989"><animateTransform attributeName="transform" type="rotate" values="0 0 0;360 0 0" times="0;1" dur="1s" calcMode="spline" keySplines="0.2 0 0.8 1" begin="-0.2" repeatCount="indefinite"></animateTransform></circle><circle cx="0" cy="0" r="25" fill="none" stroke="${waitingAndBoxColors[2]}" stroke-width="4" stroke-dasharray="78.53981633974483 78.53981633974483"><animateTransform attributeName="transform" type="rotate" values="0 0 0;-360 0 0" times="0;1" dur="1s" calcMode="spline" keySplines="0.2 0 0.8 1" begin="-0.4" repeatCount="indefinite"></animateTransform></circle><circle cx="0" cy="0" r="33.333333333333336" fill="none" stroke="${waitingAndBoxColors[3]}" stroke-width="4" stroke-dasharray="104.71975511965978 104.71975511965978"><animateTransform attributeName="transform" type="rotate" values="0 0 0;360 0 0" times="0;1" dur="1s" calcMode="spline" keySplines="0.2 0 0.8 1" begin="-0.6" repeatCount="indefinite"></animateTransform></circle><circle cx="0" cy="0" r="41.666666666666664" fill="none" stroke="${waitingAndBoxColors[4]}" stroke-width="4" stroke-dasharray="130.89969389957471 130.89969389957471"><animateTransform attributeName="transform" type="rotate" values="0 0 0;-360 0 0" times="0;1" dur="1s" calcMode="spline" keySplines="0.2 0 0.8 1" begin="-0.8" repeatCount="indefinite"></animateTransform></circle></g></svg>`,
      LineDots: () =>
        `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"  viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><g transform="translate(20 50)"><circle cx="0" cy="0" r="6" fill="${waitingAndBoxColors[0]}"><animateTransform attributeName="transform" type="scale" begin="-0.375s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform></circle></g><g transform="translate(40 50)"><circle cx="0" cy="0" r="6" fill="${waitingAndBoxColors[1]}"><animateTransform attributeName="transform" type="scale" begin="-0.25s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform></circle></g><g transform="translate(60 50)"><circle cx="0" cy="0" r="6" fill="${waitingAndBoxColors[2]}"><animateTransform attributeName="transform" type="scale" begin="-0.125s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform></circle></g><g transform="translate(80 50)"><circle cx="0" cy="0" r="6" fill="${waitingAndBoxColors[3]}"><animateTransform attributeName="transform" type="scale" begin="0s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform></circle></g></svg>`,
      Circle: () =>
        `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"  viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><circle cx="50" cy="50" fill="none" stroke="${waitingAndBoxColors[0]}" stroke-width="3" r="23" stroke-dasharray="108.38494654884786 38.12831551628262"><animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform></circle></svg>`,
      CircleDots: () =>
        `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"  viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><g><circle cx="73.801" cy="68.263" fill="${waitingAndBoxColors[0]}" r="3"><animateTransform attributeName="transform" type="rotate" calcMode="spline" values="0 50 50;360 50 50" times="0;1" keySplines="0.5 0 0.5 1" repeatCount="indefinite" dur="1.4925373134328357s" begin="0s"></animateTransform></circle><circle cx="68.263" cy="73.801" fill="${waitingAndBoxColors[1]}" r="3"><animateTransform attributeName="transform" type="rotate" calcMode="spline" values="0 50 50;360 50 50" times="0;1" keySplines="0.5 0 0.5 1" repeatCount="indefinite" dur="1.4925373134328357s" begin="-0.062s"></animateTransform></circle><circle cx="61.481" cy="77.716" fill="${waitingAndBoxColors[2]}" r="3"><animateTransform attributeName="transform" type="rotate" calcMode="spline" values="0 50 50;360 50 50" times="0;1" keySplines="0.5 0 0.5 1" repeatCount="indefinite" dur="1.4925373134328357s" begin="-0.125s"></animateTransform></circle><circle cx="53.916" cy="79.743" fill="${waitingAndBoxColors[3]}" r="3"><animateTransform attributeName="transform" type="rotate" calcMode="spline" values="0 50 50;360 50 50" times="0;1" keySplines="0.5 0 0.5 1" repeatCount="indefinite" dur="1.4925373134328357s" begin="-0.187s"></animateTransform></circle><circle cx="46.084" cy="79.743" fill="${waitingAndBoxColors[4]}" r="3"><animateTransform attributeName="transform" type="rotate" calcMode="spline" values="0 50 50;360 50 50" times="0;1" keySplines="0.5 0 0.5 1" repeatCount="indefinite" dur="1.4925373134328357s" begin="-0.25s"></animateTransform></circle><circle cx="38.519" cy="77.716" fill="${waitingAndBoxColors[5]}" r="3"><animateTransform attributeName="transform" type="rotate" calcMode="spline" values="0 50 50;360 50 50" times="0;1" keySplines="0.5 0 0.5 1" repeatCount="indefinite" dur="1.4925373134328357s" begin="-0.312s"></animateTransform></circle><circle cx="31.737" cy="73.801" fill="${waitingAndBoxColors[6]}" r="3"><animateTransform attributeName="transform" type="rotate" calcMode="spline" values="0 50 50;360 50 50" times="0;1" keySplines="0.5 0 0.5 1" repeatCount="indefinite" dur="1.4925373134328357s" begin="-0.375s"></animateTransform></circle><circle cx="26.199" cy="68.263" fill="${waitingAndBoxColors[7]}" r="3"><animateTransform attributeName="transform" type="rotate" calcMode="spline" values="0 50 50;360 50 50" times="0;1" keySplines="0.5 0 0.5 1" repeatCount="indefinite" dur="1.4925373134328357s" begin="-0.437s"></animateTransform></circle><animateTransform attributeName="transform" type="rotate" calcMode="spline" values="0 50 50;0 50 50" times="0;1" keySplines="0.5 0 0.5 1" repeatCount="indefinite" dur="1.4925373134328357s"></animateTransform></g></svg>`,
      Bricks: () =>
        `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"  viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><rect fill="${waitingAndBoxColors[0]}" x="15" y="15" width="30" height="30" rx="3" ry="3"><animate attributeName="x" dur="2s" repeatCount="indefinite" keyTimes="0;0.083;0.25;0.333;0.5;0.583;0.75;0.833;1" values="15;55;55;55;55;15;15;15;15" begin="-1.8333333333333333s"></animate><animate attributeName="y" dur="2s" repeatCount="indefinite" keyTimes="0;0.083;0.25;0.333;0.5;0.583;0.75;0.833;1" values="15;55;55;55;55;15;15;15;15" begin="-1.3333333333333333s"></animate></rect><rect fill="${waitingAndBoxColors[1]}" x="15" y="15" width="30" height="30" rx="3" ry="3"><animate attributeName="x" dur="2s" repeatCount="indefinite" keyTimes="0;0.083;0.25;0.333;0.5;0.583;0.75;0.833;1" values="15;55;55;55;55;15;15;15;15" begin="-1.1666666666666667s"></animate><animate attributeName="y" dur="2s" repeatCount="indefinite" keyTimes="0;0.083;0.25;0.333;0.5;0.583;0.75;0.833;1" values="15;55;55;55;55;15;15;15;15" begin="-0.6666666666666666s"></animate></rect><rect fill="${waitingAndBoxColors[2]}" x="15" y="15" width="30" height="30" rx="3" ry="3"><animate attributeName="x" dur="2s" repeatCount="indefinite" keyTimes="0;0.083;0.25;0.333;0.5;0.583;0.75;0.833;1" values="15;55;55;55;55;15;15;15;15" begin="-0.5s"></animate><animate attributeName="y" dur="2s" repeatCount="indefinite" keyTimes="0;0.083;0.25;0.333;0.5;0.583;0.75;0.833;1" values="15;55;55;55;55;15;15;15;15" begin="0s"></animate></rect></svg>`,
      Interwind: () =>
        `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"  viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><g transform="translate(0 -7.5)"><circle cx="50" cy="41" r="10" fill="${waitingAndBoxColors[0]}"><animateTransform attributeName="transform" type="rotate" dur="1s" repeatCount="indefinite" keyTimes="0;1" values="0 50 50;360 50 50"></animateTransform><animate attributeName="r" dur="1s" repeatCount="indefinite" calcMode="spline" keyTimes="0;0.5;1" values="0;15;0" keySplines="0.2 0 0.8 1;0.2 0 0.8 1"></animate></circle><circle cx="50" cy="41" r="10" fill="${waitingAndBoxColors[1]}"><animateTransform attributeName="transform" type="rotate" dur="1s" repeatCount="indefinite" keyTimes="0;1" values="180 50 50;540 50 50"></animateTransform><animate attributeName="r" dur="1s" repeatCount="indefinite" calcMode="spline" keyTimes="0;0.5;1" values="15;0;15" keySplines="0.2 0 0.8 1;0.2 0 0.8 1"></animate></circle></g></svg>`,
      Typing: () =>
        `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><circle cx="27.5" cy="57.5" r="5" fill="${waitingAndBoxColors[0]}"><animate attributeName="cy" calcMode="spline" keySplines="0 0.5 0.5 1;0.5 0 1 0.5;0.5 0.5 0.5 0.5" repeatCount="indefinite" values="57.5;42.5;57.5;57.5" keyTimes="0;0.3;0.6;1" dur=".7s" begin="-0.6s"></animate></circle> <circle cx="42.5" cy="57.5" r="5" fill="${waitingAndBoxColors[1]}"><animate attributeName="cy" calcMode="spline" keySplines="0 0.5 0.5 1;0.5 0 1 0.5;0.5 0.5 0.5 0.5" repeatCount="indefinite" values="57.5;42.5;57.5;57.5" keyTimes="0;0.3;0.6;1" dur=".7s" begin="-0.44999999999999996s"></animate></circle> <circle cx="57.5" cy="57.5" r="5" fill="${waitingAndBoxColors[2]}"><animate attributeName="cy" calcMode="spline" keySplines="0 0.5 0.5 1;0.5 0 1 0.5;0.5 0.5 0.5 0.5" repeatCount="indefinite" values="57.5;42.5;57.5;57.5" keyTimes="0;0.3;0.6;1" dur=".7s" begin="-0.3s"></animate></circle> <circle cx="72.5" cy="57.5" r="5" fill="${waitingAndBoxColors[3]}89bff8"><animate attributeName="cy" calcMode="spline" keySplines="0 0.5 0.5 1;0.5 0 1 0.5;0.5 0.5 0.5 0.5" repeatCount="indefinite" values="57.5;42.5;57.5;57.5" keyTimes="0;0.3;0.6;1" dur=".7s" begin="-0.15s"></animate></circle></svg>`,
      Gear: () =>
        `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"  viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><g transform="translate(50 50)"><g><animateTransform attributeName="transform" type="rotate" values="0;32.72727272727273" keyTimes="0;1" dur="0.2785515320334262s" repeatCount="indefinite"></animateTransform><path d="M29.491524206117255 -5.5 L37.491524206117255 -5.5 L37.491524206117255 5.5 L29.491524206117255 5.5 A30 30 0 0 1 27.783373422978222 11.31742732423528 L27.783373422978222 11.31742732423528 L34.51340168562767 15.64255386388006 L28.5663526936161 24.896342725023054 L21.836324430966652 20.571216185378272 A30 30 0 0 1 17.254197885979497 24.54165143814614 L17.254197885979497 24.54165143814614 L20.57751798999459 31.818707400982287 L10.57156604109489 36.38827254400304 L7.2482459370797985 29.111216581166893 A30 30 0 0 1 1.246936432518882 29.974074623468482 L1.246936432518882 29.974074623468482 L0.1084177263326025 37.892646158515944 L-10.779618134357655 36.327182937509804 L-9.641099428171374 28.408611402462345 A30 30 0 0 1 -15.15621852783466 25.88994090253049 L-15.15621852783466 25.88994090253049 L-20.395104399396942 31.935937497364556 L-28.708349717293792 24.732469423966418 L-23.46946384573151 18.686472829132352 A30 30 0 0 1 -26.74738119432351 13.58593387462007 L-26.74738119432351 13.58593387462007 L-34.42332498323949 15.839794329351507 L-37.52238310849522 5.285371619592024 L-29.84643931957924 3.031511164860587 A30 30 0 0 1 -29.84643931957924 -3.0315111648605795 L-29.84643931957924 -3.0315111648605795 L-37.52238310849522 -5.285371619592015 L-34.423324983239496 -15.839794329351498 L-26.747381194323513 -13.585933874620062 A30 30 0 0 1 -23.469463845731514 -18.686472829132345 L-23.469463845731514 -18.686472829132345 L-28.7083497172938 -24.73246942396641 L-20.395104399396963 -31.93593749736455 L-15.156218527834678 -25.889940902530483 A30 30 0 0 1 -9.641099428171389 -28.40861140246234 L-9.641099428171389 -28.40861140246234 L-10.779618134357671 -36.327182937509804 L0.1084177263325996 -37.892646158515944 L1.2469364325188814 -29.974074623468482 A30 30 0 0 1 7.248245937079778 -29.111216581166897 L7.248245937079778 -29.111216581166897 L10.571566041094865 -36.388272544003044 L20.57751798999458 -31.81870740098229 L17.25419788597949 -24.541651438146143 A30 30 0 0 1 21.83632443096665 -20.571216185378276 L21.83632443096665 -20.571216185378276 L28.566352693616096 -24.896342725023057 L34.51340168562768 -15.642553863880053 L27.783373422978226 -11.317427324235274 A30 30 0 0 1 29.491524206117255 -5.500000000000013 M0 -20A20 20 0 1 0 0 20 A20 20 0 1 0 0 -20" fill="${waitingAndBoxColors[0]}"></path></g></g></svg>`,
      Gears: () =>
        `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"  viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><g transform="translate(50 50)">  <g transform="translate(-19 -19) scale(0.6)"> <g><animateTransform attributeName="transform" type="rotate" values="0;45" keyTimes="0;1" dur="0.2s" begin="0s" repeatCount="indefinite"></animateTransform><path d="M31.359972760794346 21.46047782418268 L38.431040572659825 28.531545636048154 L28.531545636048154 38.431040572659825 L21.46047782418268 31.359972760794346 A38 38 0 0 1 7.0000000000000036 37.3496987939662 L7.0000000000000036 37.3496987939662 L7.000000000000004 47.3496987939662 L-6.999999999999999 47.3496987939662 L-7 37.3496987939662 A38 38 0 0 1 -21.46047782418268 31.35997276079435 L-21.46047782418268 31.35997276079435 L-28.531545636048154 38.431040572659825 L-38.43104057265982 28.531545636048158 L-31.359972760794346 21.460477824182682 A38 38 0 0 1 -37.3496987939662 7.000000000000007 L-37.3496987939662 7.000000000000007 L-47.3496987939662 7.000000000000008 L-47.3496987939662 -6.9999999999999964 L-37.3496987939662 -6.999999999999997 A38 38 0 0 1 -31.35997276079435 -21.460477824182675 L-31.35997276079435 -21.460477824182675 L-38.431040572659825 -28.531545636048147 L-28.53154563604818 -38.4310405726598 L-21.4604778241827 -31.35997276079433 A38 38 0 0 1 -6.999999999999992 -37.3496987939662 L-6.999999999999992 -37.3496987939662 L-6.999999999999994 -47.3496987939662 L6.999999999999977 -47.3496987939662 L6.999999999999979 -37.3496987939662 A38 38 0 0 1 21.460477824182686 -31.359972760794342 L21.460477824182686 -31.359972760794342 L28.531545636048158 -38.43104057265982 L38.4310405726598 -28.53154563604818 L31.35997276079433 -21.4604778241827 A38 38 0 0 1 37.3496987939662 -6.999999999999995 L37.3496987939662 -6.999999999999995 L47.3496987939662 -6.999999999999997 L47.349698793966205 6.999999999999973 L37.349698793966205 6.999999999999976 A38 38 0 0 1 31.359972760794346 21.460477824182686 M0 -23A23 23 0 1 0 0 23 A23 23 0 1 0 0 -23" fill="${waitingAndBoxColors[0]}"></path></g></g> <g transform="translate(19 19) scale(0.6)"> <g><animateTransform attributeName="transform" type="rotate" values="45;0" keyTimes="0;1" dur="0.2s" begin="-0.1s" repeatCount="indefinite"></animateTransform><path d="M-31.35997276079435 -21.460477824182675 L-38.431040572659825 -28.531545636048147 L-28.53154563604818 -38.4310405726598 L-21.4604778241827 -31.35997276079433 A38 38 0 0 1 -6.999999999999992 -37.3496987939662 L-6.999999999999992 -37.3496987939662 L-6.999999999999994 -47.3496987939662 L6.999999999999977 -47.3496987939662 L6.999999999999979 -37.3496987939662 A38 38 0 0 1 21.460477824182686 -31.359972760794342 L21.460477824182686 -31.359972760794342 L28.531545636048158 -38.43104057265982 L38.4310405726598 -28.53154563604818 L31.35997276079433 -21.4604778241827 A38 38 0 0 1 37.3496987939662 -6.999999999999995 L37.3496987939662 -6.999999999999995 L47.3496987939662 -6.999999999999997 L47.349698793966205 6.999999999999973 L37.349698793966205 6.999999999999976 A38 38 0 0 1 31.359972760794346 21.460477824182686 L31.359972760794346 21.460477824182686 L38.431040572659825 28.531545636048158 L28.53154563604818 38.4310405726598 L21.460477824182703 31.35997276079433 A38 38 0 0 1 6.9999999999999964 37.3496987939662 L6.9999999999999964 37.3496987939662 L6.999999999999995 47.3496987939662 L-7.000000000000009 47.3496987939662 L-7.000000000000007 37.3496987939662 A38 38 0 0 1 -21.46047782418263 31.359972760794385 L-21.46047782418263 31.359972760794385 L-28.531545636048097 38.43104057265987 L-38.431040572659796 28.531545636048186 L-31.35997276079433 21.460477824182703 A38 38 0 0 1 -37.34969879396619 7.000000000000032 L-37.34969879396619 7.000000000000032 L-47.34969879396619 7.0000000000000355 L-47.3496987939662 -7.000000000000002 L-37.3496987939662 -7.000000000000005 A38 38 0 0 1 -31.359972760794346 -21.46047782418268 M0 -23A23 23 0 1 0 0 23 A23 23 0 1 0 0 -23" fill="${waitingAndBoxColors[2]}"></path></g></g></g></svg>`,
      Rainbow: () =>
        `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><clipPath id="cp"><path d="M0 -44 A44 44 0 0 1 0 44 A44 44 0 0 1 0 -44 M24 -1L24 1L32 1L32 -1Z"></path></clipPath><g transform="translate(50,50)"><circle clip-path="url(#cp)" cx="0" cy="0" fill="none" r="27" stroke="${waitingAndBoxColors[0]}" stroke-width="6" stroke-dasharray="42.411500823462205 0 0 0 0 169.64600329384882"><animate attributeName="stroke-dasharray" dur="1.6949152542372878s" repeatCount="indefinite" begin="-0.16949152542372878s" keyTimes="0;0.2;0.4;0.6;0.8;1" values="0 0 0 0 0 169.64600329384882;0 0 0 0 0 169.64600329384882;0 0 84.82300164692441 0 0 169.64600329384882;0 0 169.64600329384882 0 0 169.64600329384882;0 0 84.82300164692441 0 0 169.64600329384882;0 0 0 0 0 169.64600329384882"></animate><animateTransform attributeName="transform" type="rotate" dur="1.6949152542372878s" repeatCount="indefinite" begin="-0.16949152542372878s" values="0;0;0;0;180;360"></animateTransform></circle><circle cx="0" cy="0" fill="none" r="34" stroke="${waitingAndBoxColors[1]}" stroke-width="6" stroke-dasharray="106.81415022205297 0 0 213.62830044410595"><animate attributeName="stroke-dasharray" dur="1.6949152542372878s" repeatCount="indefinite" begin="0s" values="0 0 0 0 0 213.62830044410595;0 0 106.81415022205297 0 0 213.62830044410595;0 0 106.81415022205297 0 0 213.62830044410595;0 0 106.81415022205297 0 0 213.62830044410595;0 0 106.81415022205297 0 0 213.62830044410595;0 0 0 0 0 213.62830044410595"></animate><animateTransform attributeName="transform" type="rotate" dur="1.6949152542372878s" repeatCount="indefinite" begin="0s" values="0;0;0;180;180;360"></animateTransform></circle><circle cx="0" cy="0" fill="none" r="41" stroke="${waitingAndBoxColors[3]}" stroke-width="6" stroke-dasharray="128.8052987971815 0 0 257.610597594363" transform="rotate(45)"><animate attributeName="stroke-dasharray" dur="1.6949152542372878s" repeatCount="indefinite" begin="0s" keyTimes="0;0.06;0.1;0.3;0.45;0.5;0.7;0.90;1" values="0 0 96.60397409788612 0 0 257.610597594363;0 0 96.60397409788612 0 0 257.610597594363;0 0 128.8052987971815 0 0 257.610597594363;0 0 128.8052987971815 0 0 257.610597594363;0 0 32.20132469929538 0 0 257.610597594363;0 0 32.20132469929538 0 0 257.610597594363;0 0 128.8052987971815 0 0 257.610597594363;0 0 128.8052987971815 0 0 257.610597594363;0 0 96.60397409788612 0 0 257.610597594363"></animate><animateTransform attributeName="transform" type="rotate" dur="1.6949152542372878s" repeatCount="indefinite" begin="0s" keyTimes="0;0.06;0.1;0.3;0.5;0.6;0.8;0.90;1" values="-60;0;0;0;180;180;180;180;300"></animateTransform></circle></g></svg>`,
      CurveBar: () =>
        `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><g transform="translate(50,50)"><circle cx="0" cy="0" r="8.333333333333334" fill="none" stroke="${waitingAndBoxColors[0]}" stroke-width="4" stroke-dasharray="26.179938779914945 26.179938779914945"><animateTransform attributeName="transform" type="rotate" values="0 0 0;-360 0 0" times="0;1" dur="1s" calcMode="spline" keySplines="0.2 0 0.8 1" begin="0" repeatCount="indefinite"></animateTransform></circle><circle cx="0" cy="0" r="16.666666666666668" fill="none" stroke="${waitingAndBoxColors[1]}" stroke-width="4" stroke-dasharray="52.35987755982989 52.35987755982989"><animateTransform attributeName="transform" type="rotate" values="0 0 0;360 0 0" times="0;1" dur="1s" calcMode="spline" keySplines="0.2 0 0.8 1" begin="-0.2" repeatCount="indefinite"></animateTransform></circle><circle cx="0" cy="0" r="25" fill="none" stroke="${waitingAndBoxColors[2]}" stroke-width="4" stroke-dasharray="78.53981633974483 78.53981633974483"><animateTransform attributeName="transform" type="rotate" values="0 0 0;-360 0 0" times="0;1" dur="1s" calcMode="spline" keySplines="0.2 0 0.8 1" begin="-0.4" repeatCount="indefinite"></animateTransform></circle><circle cx="0" cy="0" r="33.333333333333336" fill="none" stroke="${waitingAndBoxColors[3]}" stroke-width="4" stroke-dasharray="104.71975511965978 104.71975511965978"><animateTransform attributeName="transform" type="rotate" values="0 0 0;360 0 0" times="0;1" dur="1s" calcMode="spline" keySplines="0.2 0 0.8 1" begin="-0.6" repeatCount="indefinite"></animateTransform></circle><circle cx="0" cy="0" r="41.666666666666664" fill="none" stroke="${waitingAndBoxColors[4]}" stroke-width="4" stroke-dasharray="130.89969389957471 130.89969389957471"><animateTransform attributeName="transform" type="rotate" values="0 0 0;-360 0 0" times="0;1" dur="1s" calcMode="spline" keySplines="0.2 0 0.8 1" begin="-0.8" repeatCount="indefinite"></animateTransform></circle></g></svg>`,
    };

    const defaultWaitAndBoxSvg = Object.keys(waitAndBoxSvg);

    function rw(m, o, svg, isCustom = false) {
      const ex = document.getElementById(ws.cid);
      if (!ex) {
        const s = o && typeof o === "object" ? { ...ws, ...o } : ws;
        let html = `<div id=${ws.cid} class="f f__cw" style="background:${
          s.background
        }"><div class="f__w" style="width:${s.containerSize}">${
          isCustom
            ? svg
            : `<div style="width:${s.svgSize.w};height:${s.svgSize.h};">${svg}</div>`
        }${
          m
            ? '<p style="font-size:' +
              s.textSize +
              ";color:" +
              s.textColor +
              ";font-family:" +
              s.fontFamily +
              '">' +
              m +
              "</p>"
            : ""
        }</div></div>`;
        html = toHtml(html);
        if (s.clickToClose) html.addEventListener("click", () => Wait.Remove());
        document.body.appendChild(html);
      } else {
        cError(
          "Waiting Existed!",
          "Waiting box is already existed. you need to call Change function instead."
        );
      }
    }
    const addWait = (name) => {
      return (m, o) => {
        let s = !o ? ws : { ...ws, ...o };
        waitingAndBoxColors = gShades(s.svgColor, 9);
        rw(m, o, waitAndBoxSvg[name](), !defaultWaitAndBoxSvg.includes(name));
      };
    };
    const Wait = {};
    Wait.Init = (o) => {
      ws = Init(ws, o)
    };
    Object.keys(waitAndBoxSvg).forEach((c) => {
      Wait[c] = addWait(c);
      // Wait[c] = (m, o) => {
      //   let s = !o ? ws : { ...ws, ...o };
      //   waitingAndBoxColors = gShades(s.svgColor, 9);
      //   rw(m, o, waitAndBoxSvg[c]());
      // };
    });
    Wait.Change = function (m) {
      const c = document.getElementById(ws.cid);
      if (c) {
        let p = c.querySelector("p");
        if (p) {
          if (m) {
            p.innerHTML = m;
          } else {
            p.remove();
          }
        } else {
          p = toHtml(
            `<p style="font-size:${ws.textSize};color:${ws.textColor}"></p>`
          );
          p.innerHTML = m;
          let wbox = c.querySelector(".f__w");
          wbox.appendChild(p);
        }
      }
    };
    Wait.Remove = function (ms) {
      let w = document.getElementById(ws.cid);
      const rem = function () {
        // w.style.opacity = 0;
        // setTimeout(() => {
        //     w.remove();
        // }, 600);
        w.remove();
      };
      if (w) {
        if (typeof ms === "number") {
          setTimeout(() => {
            rem();
          }, ms);
        } else {
          rem();
        }
      }
    };
    //#endregion

    //#region  Box
    let bs = {
      cid: idEng(12),
      fontFamily: defaultFont,
      svgSize: { w: "100px", h: "100px" },
      svgColor: GColors.Primary,
      background: "rgba(255,255,255,0.8)",
      zindex: 4000,
      textColor: "#029eff",
      textSize: "16px",
    };

    function rb(sel, m, o, svg, isCustom = false) {
      const ex =
        typeof sel === "object"
          ? sel
          : typeof sel === "string"
          ? document.querySelector(sel)
          : null;
      if (ex) {
        ex.setAttribute("data-pos", ex.style.position);
        ex.style.position = "relative";
        const s = o && typeof o === "object" ? { ...bs, ...o } : bs;
        let html = `<div data-id="${
          bs.cid
        }" class="f f__cb" style="background:${s.background}">${
          isCustom
            ? svg
            : `<div class="f__w"><div style="width:${s.svgSize.w};height:${s.svgSize.h};">${svg}</div>`
        }${
          m
            ? '<p style="font-size:' +
              s.textSize +
              ";color:" +
              s.textColor +
              ";font-family:" +
              s.fontFamily +
              '">' +
              m +
              "</p>"
            : ""
        }</div></div>`;
        html = toHtml(html);
        ex.appendChild(html);
      } else {
        cError(
          "Invalid Selector!",
          sel + " is invalid selector or no element found by this selector."
        );
      }
    }
    const addBox = (name) => {
      return (selector, message, obj) => {
        let s = !obj ? bs : { ...bs, ...obj };
        waitingAndBoxColors = gShades(s.svgColor, 9);
        rb(
          selector,
          message,
          obj,
          waitAndBoxSvg[name](),
          !defaultWaitAndBoxSvg.includes(name)
        );
      };
    };
    const Box = {};
    Box.Init = (o) => {
      bs = Init(bs, o)
    };
    Object.keys(waitAndBoxSvg).forEach((c) => {
      Box[c] = addBox(c);
      // Box[c] = (selector, message, obj) => {
      //   let s = !obj ? bs : { ...bs, ...obj };
      //   waitingAndBoxColors = gShades(s.svgColor, 9);
      //   rb(selector, message, obj, waitAndBoxSvg[c]());
      // };
    });
    Box.Remove = function (selector, ms) {
      let w =
        typeof selector === "object"
          ? selector.querySelector(`div[data-id="${bs.cid}"]`)
          : typeof selector === "string"
          ? document.querySelector(selector + ` div[data-id="${bs.cid}"]`)
          : null;
      if (!w) {
        cError(
          "Invalid Selector",
          sel + " is invalid selector or no element found by this selector."
        );
      } else {
        let p = w.parentElement;
        const rem = function () {
          w.style.opacity = 0;
          setTimeout(() => {
            w.remove();
            let orgPos = p.getAttribute("data-pos");
            p.style.position = orgPos ? orgPos : "";
            p.removeAttribute("data-pos");
          }, 100);
        };
        if (w) {
          if (typeof ms === "number") {
            setTimeout(() => {
              rem();
            }, ms);
          } else {
            rem();
          }
        }
      }
    };
    //#endregion

    //**
    //* Add Custom Theme to Ask, Alert, Dilog
    //* @param {*} name
    //* @param {*} values
    //*/
    var _fnOb = {
      Ask,
      Alert,
      Dialogue,
      Hint,
      Wait,
      Box,
    };
    var customTheme = (name, values = {}) => {
      if (!name) {
        cError("Name is required to generate a new theme.");
        return;
      }
      if (Ask[name]) {
        cError("A theme with the same name already exists.");
        return;
      }
      // add themes
      _fnOb.Alert[name] = addAlert(Init(alertSettings, values));
      _fnOb.Dialogue[name] = addDialogue(Init(dialogueSettings, values));
      _fnOb.Ask[name] = addAsk(Init(askSettings, values));
      _fnOb.Hint[name] = addHint({ ...hints.Primary, ...values });
    };
    _fnOb.AddTheme = customTheme;
    // be able to add custom logo to Wait and Box
    var customLogo = (name, htmlContentAsString) => {
      if (!name || !htmlContentAsString) {
        cError("Name and HtmlContent are required to add a new logo.");
        return;
      }
      if (Wait[name]) {
        cError("A logo with the same name already exists.");
        return;
      }
      waitAndBoxSvg[name] = () => htmlContentAsString;
      Wait[name] = addWait(name);
      Box[name] = addBox(name);
    };
    _fnOb.AddLogo = customLogo;

    return _fnOb;
  }
);
